import { Chat } from '../types/chat';
import { Listing } from '../types/listing';

export interface ChatWithListing extends Chat {
  listing?: Listing;
}

export interface ChatsConnection {
  items: Chat[];
  nextToken?: string;
}

export interface ChatsWithListingConnection {
  items: ChatWithListing[];
  nextToken?: string;
}

export interface GetUserChatsResponse {
  getUserChats: {
    items: Chat[];
    nextToken: string | null;
  };
}

export interface GetUserChatsWithListingResponse {
  getUserChats: ChatsWithListingConnection;
}

export interface GetUserChatsVariables {
  limit?: number;
  nextToken?: string | null;
}

export const getUserChatsQuery = `
  query GetUserChats($limit: Int, $nextToken: String) {
    getUserChats(limit: $limit, nextToken: $nextToken) {
      items {
        id
        listingId
        senderId
        receiverId
        lastMessage {
          id
          chatId
          senderId
          receiverId
          text
          createdAt
        }
        unreadCount
        createdAt
        updatedAt
        leftAtBy {
          sender
          receiver
        }
        receiverId
        receiver {
          id
          name
          photo
          phones
          chatEnabled
          createdAt
          updatedAt
        }
        selfBlock
        peerBlock
        listing {
          id
          name
          photo
          price {
            azn
            usd
          }
          badges {
            credit
            barter
          }
          shop {
            id
            name
            link
            logo
          }
        }
      }
      nextToken
    }
  }
`;

export const getUserChatsWithListingQuery = `
  query GetUserChats($limit: Int, $nextToken: String) {
    getUserChats(limit: $limit, nextToken: $nextToken) {
      items {
        id
        listingId
        senderId
        receiverId
        lastMessage
        unreadCount
        createdAt
        updatedAt
        listing {
          id
          projectId
          name
          price {
            azn
            usd
          }
          photo
          badges {
            credit
            barter
          }
          shop {
            id
            name
            link
            logo
          }
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;

export interface GetChatResponse {
  getChat: Chat | null;
}

export interface GetChatVariables {
  listingId: string;
  receiverId: string;
}

export const getChatQuery = `
  query GetChat($listingId: ID!, $receiverId: ID!) {
    getChat(listingId: $listingId, receiverId: $receiverId) {
      id
      listingId
      senderId
      receiverId
      lastMessage {
          id
          chatId
          senderId
          receiverId
          text
          createdAt
      }
      unreadCount
      createdAt
      updatedAt
      selfBlock
      peerBlock
      leftAtBy {
          sender
          receiver
      }
      receiverId
      receiver {
          id
          name
          photo
          phones
          chatEnabled
          createdAt
          updatedAt
      }
      listing {
          id
          name
          price {
            azn
            usd
          }
          photo
          badges {
            credit
            barter
          }
          shop {
            id
            name
            link
            logo
          }
          createdAt
          updatedAt
        }
    }
  }
`;

export const getChatByIdQuery = `
  query GetChatById($chatId: ID!) {
    getChatById(chatId: $chatId) {
      id
      listingId
      senderId
      receiverId
      lastMessage {
          id
          chatId
          senderId
          receiverId
          text
          createdAt
      }
      unreadCount
      createdAt
      updatedAt
      selfBlock
      peerBlock
      leftAtBy {
          sender
          receiver
      }
      receiverId
      receiver {
          id
          name
          photo
          phones
          chatEnabled
          createdAt
          updatedAt
      }
      listing {
          id
          name
          price {
            azn
            usd
          }
          photo
          badges {
            credit
            barter
          }
          shop {
            id
            name
            link
            logo
          }
          createdAt
          updatedAt
        }
    }
  }
`;
